exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle,.point,.shapes li{color:#009fe3}main{display:flex;flex-direction:column}@media (min-width:800px){main{position:fixed;top:0;left:0;height:100%;right:23.625rem;padding:.25rem .25rem .25rem .75rem;touch-action:none}main .panel.dark{display:none}}.v--modal-overlay{background:rgba(0,0,0,.8)}.v--modal-top-right{z-index:9999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-661125d1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ClipPath.vue
// module id = 353
// module chunks = 0